import * as React from "react";

export class EmptyTemplateItem extends React.Component<EmptyTemplateItemProps, EmptyTemplateItemState> {
    static defaultProps: Partial<EmptyTemplateItemProps> = {};

    constructor(props: EmptyTemplateItemProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <div className="sfTemplateItem" onClick={this.props.OnClick}>
                <div className="sfImage">
                    <img style={{width:'100%',height:'100%'}}  src={smartFormsPath+'images/blankpage.svg'}/>
                </div>
                <hr style={{margin:'1px 0 0 0'}}/>
                <div className="sfText" ><h2 style={{fontSize:'17px !important',textAlign:'center'}}>Empty Form</h2></div>
            </div>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface EmptyTemplateItemProps {
    OnClick:any;
}

interface EmptyTemplateItemState {

}

//#endregion "My Region"